<script>
import { amountToWords } from "@/helpers/amountToWords";

/**
 * Renders Indian-numbering amount-in-words for invoices.
 * Wraps the existing helper so callers don't have to import it.
 */
export default {
  name: "PrintAmountInWords",
  props: {
    amount: { type: Number, required: true },
    label: { type: String, default: "Amount in Words" },
  },
  computed: {
    inWords() {
      try {
        return amountToWords(this.amount);
      } catch (_) {
        return "";
      }
    },
  },
};
</script>

<template>
  <div class="print-amount-words">
    <span class="print-amount-words-label">{{ label }}:</span>
    <span class="print-amount-words-value">{{ inWords }}</span>
  </div>
</template>

<style scoped>
.print-amount-words {
  border: 0.5pt solid var(--print-border);
  padding: 1mm 2mm;
  margin: 2mm 0;
  font-size: var(--print-fs-sm);
  page-break-inside: avoid;
  break-inside: avoid;
}

.print-amount-words-label {
  color: var(--print-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: var(--print-fs-xs);
  margin-right: 1.5mm;
  font-weight: 600;
}

.print-amount-words-value {
  font-weight: 500;
}
</style>
